import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo_s from "../assets/img/logo_s.svg";
import user_1 from "../assets/img/user_1.svg";
import styles from "./loginPage.module.scss";
import { forgotpassword, verificationOtp } from "../redux/Action";

const Verification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const btnLoading = useSelector((state) => state.main.btnLoading);
  const [time, setTime] = useState(60);
  const [reOtp, setReOtp] = useState(false);
  const curntemail = localStorage.getItem("forgotEmail");

  // Timer logic
  useEffect(() => {
    if (time > 0) {
      const timerId = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId); // Cleanup on unmount or time change
    } else {
      setReOtp(true); // Enable resend when timer reaches 0
    }
  }, [time]);

  const resendOtp = async () => {
    setReOtp(false);
    setTime(60); // Reset timer
    const data = { email: curntemail };
    dispatch(forgotpassword(data, navigate, "no-route"));
  };

  const initialValues = {
    email: curntemail || "",
    otp: "",
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      email: Yup.string().email().required("Please enter your email"),
      otp: Yup.string().required("Please enter OTP"),
    }),
    onSubmit: (values, { resetForm }) => {
      dispatch(verificationOtp(values, navigate));
      resetForm();
    },
  });

  return (
    <div className="login-page">
      <div className={styles.wrapper_login}>
        <div className={styles.wrap_login}>
          <img src={logo_s} alt="Logo" />
        </div>
        <form className={styles.login_form} onSubmit={handleSubmit}>
          <h1 className={styles.forget_pass}>Verification</h1>
          <div className={styles.wrap_input}>
            <input
              className={styles.input100}
              type="text"
              name="otp"
              placeholder="Enter the 4-digit code"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.otp}
            />
            <span className={styles.focus_input100}>
              <img src={user_1} alt="User icon" />
            </span>
            {errors.otp && touched.otp && (
              <div className={styles.input_feedback}>{errors.otp}</div>
            )}
            <div className="p-opt">
              {reOtp ? (
                <h5 onClick={resendOtp}>
                  <span>
                    <p>Resend</p>
                  </span>
                </h5>
              ) : (
                <h6>
                  OTP resend in {Math.floor(time / 60)}:
                  {(time % 60).toString().padStart(2, "0")}
                </h6>
              )}
            </div>
          </div>

          <button
            className={styles.btn_dark}
            type="submit"
            disabled={btnLoading}
          >
            Verify
          </button>
        </form>
      </div>
    </div>
  );
};

export default Verification;
